import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A1918] text-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-display font-extrabold text-3xl md:text-4xl tracking-tighter">
              E-PRO<span className="text-[#C86641]">.</span>Intervention
            </div>
            <p className="mt-4 text-[#A8A7A3] max-w-md leading-relaxed">
              Vos travaux, notre savoir-faire. Rénovation et finitions premium en Île-de-France et régions voisines.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.2em] uppercase text-[#A8A7A3] font-bold">Navigation</div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/" className="hover:text-[#C86641] transition-colors">Accueil</Link></li>
              <li><a href="/#services" className="hover:text-[#C86641] transition-colors">Services</a></li>
              <li><a href="/#realisations" className="hover:text-[#C86641] transition-colors">Réalisations</a></li>
              <li><Link to="/devis" className="hover:text-[#C86641] transition-colors">Demander un devis</Link></li>
              <li><Link to="/connexion" className="hover:text-[#C86641] transition-colors">Connexion client</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.2em] uppercase text-[#A8A7A3] font-bold">Contact</div>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={18} className="mt-0.5 text-[#C86641]" />
                <a href="tel:0660413073" data-testid="footer-phone">06.60.41.30.73</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="mt-0.5 text-[#C86641]" />
                <a href="mailto:valdoise-95@hotmail.com" data-testid="footer-email" className="break-all">
                  valdoise-95@hotmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 text-[#C86641]" />
                <span>Île-de-France &amp; régions voisines</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-[#A8A7A3]">
          <div>© {new Date().getFullYear()} E-PRO.Intervention — Tous droits réservés.</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-[#FAFAFA] transition-colors">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" data-testid="footer-confidentialite" className="hover:text-[#FAFAFA] transition-colors">Politique de confidentialité</Link>
            <span>Micro-entreprise — Île-de-France</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
